import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appPhoneMask]',
    standalone: false
})
export class PhoneMaskDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;

    this._el.nativeElement.value = initalValue.replace(/\D*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
    if (this._el.nativeElement.value.length === 0) {
      this._el.nativeElement.value = '';
    } else if (this._el.nativeElement.value.length <= 3) {
      this._el.nativeElement.value = this._el.nativeElement.value.replace(/^(\d{0,3})/, '$1');
    } else if (this._el.nativeElement.value.length <= 9) {
      this._el.nativeElement.value = this._el.nativeElement.value.replace(/^(\d{0,3})(\d{0,3})/, '$1$2');
    } else if (this._el.nativeElement.value.length > 9) {
      this._el.nativeElement.value = this._el.nativeElement.value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
    } else {
      this._el.nativeElement.value = this._el.nativeElement.value.substring(0, 10);
      this._el.nativeElement.value = this._el.nativeElement.value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
    }
  }

}
